import { type ActionType } from "~/app/store/types";
import { UPDATE_NAVIGATIONBREADCRUMS } from "~/features/breadcrumbs/redux/actions";
import { type BreadcrumbItem } from "~/features/breadcrumbs/components/NavigationBreadcrumbs";

export interface NavigationBreadcrumbsState {
  list: BreadcrumbItem[];
}

const INITIAL_STATE: NavigationBreadcrumbsState = {
  list: [],
};

export const navigationBreadcrumbsReducer = (
  state: NavigationBreadcrumbsState = INITIAL_STATE,
  action: ActionType<any>,
): NavigationBreadcrumbsState => {
  switch (action.type) {
    case UPDATE_NAVIGATIONBREADCRUMS: {
      return {
        list: action.payload.breadcrumbs,
      };
    }

    default: {
      return state;
    }
  }
};
